module.exports = __webpack_public_path__ + "static/img/icon-ens-item5.abd1743.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-ens-item5.png
// module id = soCe
// module chunks = 21